const TimesheetApproval = () => {
    return (
      <div className="p-6 bg-white rounded-lg shadow-md min-h-[80vh]">
        <h2 className="text-2xl font-bold mb-4 text-orange-600">Timesheet Approval</h2>
        <p>Review and approve timesheets submitted by your team members.</p>
        <table className="w-full mt-4 border-collapse border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-4 py-2">Employee</th>
              <th className="border px-4 py-2">Week</th>
              <th className="border px-4 py-2">Hours</th>
              <th className="border px-4 py-2">Status</th>
              <th className="border px-4 py-2">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">John Doe</td>
              <td className="border px-4 py-2">Dec 1 - Dec 7</td>
              <td className="border px-4 py-2">40</td>
              <td className="border px-4 py-2 text-yellow-600">Pending</td>
              <td className="border px-4 py-2">
                <button className="px-2 py-1 bg-green-500 text-white rounded mr-2">Approve</button>
                <button className="px-2 py-1 bg-red-500 text-white rounded">Reject</button>
              </td>
            </tr>
            {/* Add more rows */}
          </tbody>
        </table>
      </div>
    );
  };
  
  export default TimesheetApproval;
  